import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import StepPill from './StepPill';

const StepIndicatorContainer = styled.div`
  height: 60px;
  background-color: ${props => props.theme.color.white};
  box-shadow: ${props => props.theme.boxShadow['3']};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
`;

const StepLine = styled.div`
  width: 80px;
  height: 2px;
  background-color: ${props => props.theme.color.border};
`;

const StepIndicator = ({ steps, currentStep, visitedStep, goToStep }) => {
  return (
    <StepIndicatorContainer>
      {steps.map((step, index) =>
        <Step key={step.label}>
          <StepPill
            index={index}
            label={step.label}
            currentStep={currentStep}
            visitedStep={visitedStep}
            goToStep={goToStep}
          />
          {index < steps.length - 1 && <StepLine />}
        </Step>
      )}
    </StepIndicatorContainer>
  );
};

StepIndicator.propTypes = {
  steps: PropTypes.array,
  currentStep: PropTypes.number,
  visitedStep: PropTypes.number,
  goToStep: PropTypes.func
};

export default StepIndicator;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/components/StepIndicator.js